module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_3016.4eb94d2e.png";